module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/collegiate-share-image-78326d4cdd9b5d92dbd40c5dc924d648.jpg";